import { AuthError } from "@aybuben/client/auth/source.ts";
import { OAuthProvider, type Account } from "appwrite";

/**
 * OAuth2 providers that work with createOAuth2Session (client-side flow).
 * Keep in sync with the Appwrite SDK's OAuthProvider enum.
 */
const OAUTH_PROVIDERS: Record<string, OAuthProvider> = {
	Google: OAuthProvider.Google,
	Github: OAuthProvider.Github,
	Apple: OAuthProvider.Apple,
	Microsoft: OAuthProvider.Microsoft,
	Discord: OAuthProvider.Discord,
	Facebook: OAuthProvider.Facebook,
};

/** The web's OAuth start: createOAuth2Session redirects the browser, so it never returns. */
export const webStartOAuth =
	(account: Pick<Account, "createOAuth2Session">) =>
	(provider: string, successUrl: string, failureUrl: string): void => {
		const providerEnum = OAUTH_PROVIDERS[provider];
		if (!providerEnum) throw new AuthError("unknown");
		account.createOAuth2Session({
			provider: providerEnum,
			success: successUrl,
			failure: failureUrl,
		});
	};
